var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-area',_vm._g(_vm._b({attrs:{"label":"Anotações","no-resize":"","max-length":2000,"rows":4},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'text-area',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }